import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import emailjs from '@emailjs/browser';

const SUBJECTS = [
  { value: '',                  label: 'Select a subject' },
  { value: 'report-issue',      label: 'Issue with my report' },
  { value: 'payment-issue',     label: 'Payment issue' },
  { value: 'general-enquiry',   label: 'General enquiry' },
  { value: 'technical-support', label: 'Technical support' },
  { value: 'refund-request',    label: 'Refund request' },
  { value: 'other',             label: 'Other' },
];

export default function Contact() {
  const [form, setForm] = useState({
    firstName: '', lastName: '', email: '', phone: '',
    subject: '', orderId: '', message: '',
  });
  const [errors,    setErrors]    = useState({});
  const [submitted, setSubmitted] = useState(false);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
    if (errors[field]) setErrors((e) => ({ ...e, [field]: '' }));
  }

  function validate() {
    const e = {};
    if (!form.firstName.trim()) e.firstName = 'First name is required';
    if (!form.lastName.trim())  e.lastName  = 'Last name is required';
    if (!form.email.trim())     e.email     = 'Email address is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Please enter a valid email';
    if (!form.subject)          e.subject   = 'Please select a subject';
    if (!form.message.trim())   e.message   = 'Message is required';
    return e;
  }

  const EMAILJS_SERVICE_ID = process.env.EMAILJS_SERVICE_ID || 'service_6sunywh';
  const EMAILJS_TEMPLATE_ID = process.env.EMAILJS_TEMPLATE_ID || 'template_0pwe78h';
  const EMAILJS_PUBLIC_KEY = process.env.EMAILJS_PUBLIC_KEY || 'pNUS8xsk6_o5fxXZd';

  function handleSubmit(e) {
    e.preventDefault();
    console.log('BEGIN:handleSubmit()');
    const errs = validate();

    emailjs.sendForm(
      EMAILJS_SERVICE_ID, 
      EMAILJS_TEMPLATE_ID, 
      form.current, 
      EMAILJS_PUBLIC_KEY
    )
    .then((result) => {
        console.log("Message Sent!");
        console.log(result.text);
    }, (error) => {
        console.log(error.text);
    });

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    // In production: POST to /api/contact
    setSubmitted(true);
  }

  if (submitted) {
    return (
      <>
        <Header />
        <section className="page-header">
          <div className="container">
            <h1>Contact Us</h1>
          </div>
        </section>
        <section className="contact-section">
          <div className="container">
            <div className="contact-success">
              <i className="fas fa-check-circle"></i>
              <h2>Message Sent!</h2>
              <p>Thank you for contacting us. We'll get back to you within one business day.</p>
              <button className="btn btn-primary" onClick={() => setSubmitted(false)}>Send Another Message</button>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Have a question? Our support team is here to help Monday–Friday, 8:30am–6pm AEST.</p>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid ">
            {/* Contact Info */}
            <div className="contact-info">
              <h3>Get in Touch</h3>
              {/*{[
                { icon: 'fa-phone',    label: 'Phone',  value: '1300 799 523' },
                { icon: 'fa-envelope', label: 'Email',  value: 'info@ppsr-services.com.au' },
                { icon: 'fa-clock',    label: 'Hours',  value: 'Mon–Fri 8:30am–6pm AEST' },
              ].map((c) => (
                <div key={c.label} className="contact-method">
                  <i className={`fas ${c.icon}`}></i>
                  <div>
                    <strong>{c.label}</strong>
                    <span>{c.value}</span>
                  </div>
                </div>
              ))}*/}
            </div>

            {/* Contact Form */}
            <form className="contact-form" onSubmit={handleSubmit} noValidate ref={form}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text" id="firstName" name="firstName"
                    value={form.firstName} onChange={(e) => update('firstName', e.target.value)}
                    placeholder="John"
                  />
                  {errors.firstName && <span className="field-error">{errors.firstName}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text" id="lastName" name="lastName"
                    value={form.lastName} onChange={(e) => update('lastName', e.target.value)}
                    placeholder="Smith"
                  />
                  {errors.lastName && <span className="field-error">{errors.lastName}</span>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email" id="email" name="email"
                    value={form.email} onChange={(e) => update('email', e.target.value)}
                    placeholder="you@example.com"
                  />
                  {errors.email && <span className="field-error">{errors.email}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone (optional)</label>
                  <input
                    type="tel" id="phone" name="phone"
                    value={form.phone} onChange={(e) => update('phone', e.target.value)}
                    placeholder="0400 000 000"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject" name="subject"
                    value={form.subject} onChange={(e) => update('subject', e.target.value)}
                  >
                    {SUBJECTS.map((s) => (
                      <option key={s.value} value={s.value} disabled={!s.value}>{s.label}</option>
                    ))}
                  </select>
                  {errors.subject && <span className="field-error">{errors.subject}</span>}
                </div>
                <div className="form-group">
                  <label htmlFor="orderId">Order ID (optional)</label>
                  <input
                    type="text" id="orderId" name="orderId"
                    value={form.orderId} onChange={(e) => update('orderId', e.target.value)}
                    placeholder="e.g., PPSR-2024-00001234"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message" rows={5} name="message"
                  value={form.message} onChange={(e) => update('message', e.target.value)}
                  placeholder="Please describe your issue or question…"
                />
                {errors.message && <span className="field-error">{errors.message}</span>}
              </div>

              <button type="submit" className="btn btn-primary btn-large">
                <i className="fas fa-paper-plane"></i> Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
